module.exports = __webpack_public_path__ + "img/pmi.6f6fe2b.svg";